import React from "react";
import { Check } from "lucide-react";
import { Marker } from "./StatusMarker.styles";
import type { StatusMarkerProps } from "./StatusMarker.types";

/** A round state marker: green check (done), amber or red "!" (warn, bad), filled (current) or a ring (todo). */
export const StatusMarker: React.FC<StatusMarkerProps> = ({ state, label, ariaLabel, className }) => (
  <Marker
    $state={state}
    className={className}
    data-state={state}
    role={ariaLabel ? "img" : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
  >
    {state === "done" ? <Check strokeWidth={4} aria-hidden="true" /> : state === "todo" ? null : label}
  </Marker>
);

export default StatusMarker;
